import React from "react";

const DetailSkeleton: React.FC = () => {
  return (
    <div className="detail-skeleton">
      {/* 상단 헤더 스켈레톤 */}
      <div className="detail-skeleton__header">
        <div className="detail-skeleton__top-line">
          <div className="detail-skeleton__top-left">
            <div className="detail-skeleton__title" />
            <div className="detail-skeleton__divider" />
            <div className="detail-skeleton__product-icon" />
            <div className="detail-skeleton__product-name" />
            <div className="detail-skeleton__tag" />
          </div>
          <div className="detail-skeleton__top-right">
            <div className="detail-skeleton__share-btn" />
            <div className="detail-skeleton__close-btn" />
          </div>
        </div>
      </div>

      {/* 중앙 컨텐츠 스켈레톤 */}
      <div className="detail-skeleton__content">
        <div className="detail-skeleton__content-container">
          <div className="detail-skeleton__content-left">
            <div className="detail-skeleton__text-line" />
            <div className="detail-skeleton__text-line" />
            <div className="detail-skeleton__text-line" />
            <div className="detail-skeleton__text-line short" />
          </div>
          <div className="detail-skeleton__divide-line" />
          <div className="detail-skeleton__article-link">
            <div className="detail-skeleton__link-title" />
            <div className="detail-skeleton__link-item" />
            <div className="detail-skeleton__link-item" />
          </div>
        </div>

        <div className="detail-skeleton__divide-vertical-line" />

        <div className="detail-skeleton__mobile-section">
          <div className="detail-skeleton__image-slider">
            <div className="detail-skeleton__image-wrapper">
              <div className="detail-skeleton__image-container">
                <div className="detail-skeleton__image" />
                <div className="detail-skeleton__image-desc">
                  <div className="detail-skeleton__desc-title" />
                  <div className="detail-skeleton__desc-text" />
                </div>
              </div>
              <div className="detail-skeleton__image-container">
                <div className="detail-skeleton__image" />
                <div className="detail-skeleton__image-desc">
                  <div className="detail-skeleton__desc-title" />
                  <div className="detail-skeleton__desc-text" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 하단 작성자 정보 스켈레톤 */}
      <div className="detail-skeleton__author">
        <div className="detail-skeleton__author-title">
          <div className="detail-skeleton__author-text" />
          <div className="detail-skeleton__author-name" />
        </div>
        <div className="detail-skeleton__author-buttons">
          <div className="detail-skeleton__contact-btn" />
          <div className="detail-skeleton__contact-btn" />
          <div className="detail-skeleton__contact-btn" />
        </div>
      </div>
    </div>
  );
};

export default DetailSkeleton;
